<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">Client Deposit Invoice Preview</h2>
        </span>

        <span class="d-flex gap-3 align-items-center customizefilter-btn">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />
          <span class="cross-border" (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          stripedRows
          [rows]="25"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [resizableColumns]="true"
          responsiveLayout="scroll"
          [value]="ipClientDepositDetailValue"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [autoLayout]="true"
          [resizableColumns]="true"
          [paginator]="ipClientDepositDetailValue.length >= 20"
          styleClass="table-listing">
          <!-- <ng-template pTemplate="caption">
            <div class="d-flex align-items-center">
              <ng-container> </ng-container>
            </div>
          </ng-template> -->
          <ng-template pTemplate="header">
            <tr class="table-head">
              <!-- <th>Charges Code</th> -->
              <th style="width: 6rem">Creation Date</th>
              <th style="width: 10rem" pSortableColumn="Amount">
                Amount
                <p-sortIcon field="Amount"></p-sortIcon>
              </th>
              <th pSortableColumn="Txt">
                Description
                <p-sortIcon field="Txt"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="Amount"
                    id="Amount"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'Amount',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="Txt"
                    id="Txt"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'Txt', 'startsWith')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-clientDepositList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="clientDepositList"
              [pSelectableRowIndex]="rowIndex">
              <td>{{ clientDepositList?.InvoiceDate | date: "yyyy-MM-dd" }}</td>
              <td>{{ clientDepositList?.Amount | currency }}</td>
              <td>{{ clientDepositList?.Txt }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Data Found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>
